// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__20Zjc","title":"Images45_title__cuqPq","images":"Images45_images__2hMkT"};